module.exports = __webpack_public_path__ + "img/family@3x.c44a345e.png";